import { ref, type Ref } from "vue";
import { AppIdentifier } from "@/shared/@types/AppIdentifier";
import { verifyEmail } from "../services/verifyEmail.service";
import { useNotifications } from "@/shared/composables/useNotifications.composable";
import { useI18n } from "vue-i18n";

const toLogin = () => {
  setTimeout(() => {
    window.location.href = `/${AppIdentifier.Equivolt}/stations`;
  }, 2000);
};

export const useVerifyEmail = ({
  email,
  token,
}: {
  email: Ref<string | undefined>;
  token: Ref<string | undefined>;
}) => {
  const { t } = useI18n();

  const isVerifyingEmail = ref(false);
  const verifyingEmailError = ref(false);
  const settingPasswordError = ref(false);

  const { addSuccessSnackbar } = useNotifications();

  const onVerifyEmail = async (password: string) => {
    if (!email.value || !token.value) return;
    settingPasswordError.value = false;
    try {
      isVerifyingEmail.value = true;
      const passwordSet = await verifyEmail({
        email: email.value,
        token: token.value,
        password,
      });
      settingPasswordError.value = passwordSet === false;
      if (passwordSet === true) {
        addSuccessSnackbar(t("registration.user.verifyEmail.success"));
        toLogin();
      }
    } catch {
      verifyingEmailError.value = true;
    } finally {
      isVerifyingEmail.value = false;
    }
  };

  return {
    isVerifyingEmail,
    verifyingEmailError,
    settingPasswordError,
    onVerifyEmail,
  };
};
